export const CHECKOUT_VERSION = "v2";
export const LIBRARIES: "marker"[] = ["marker"]; // Google Maps API libraries
export const MAP_CONTAINER_STYLE = { width: "100%", height: "100%" }; // Map container style
